import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const MainContent = superstyled({
  name: 'StandaloneReportPanel',
  slot: 'MainContent',
  tag: Box,
  styles: ({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden'
  })
});

export const ContentHeader = superstyled({
  name: 'StandaloneReportPanel',
  slot: 'ContentHeader',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    padding: theme.spacing(3, 3, 0, 3),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1.5, 1.5, 0, 1.5)
    }
  })
});

export const ContentSubHeader = superstyled({
  name: 'StandaloneReportPanel',
  slot: 'ContentSubHeader',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(2),
      padding: theme.spacing(1, 0)
    }
  })
});

export const ContentTitle = superstyled({
  name: 'StandaloneReportPanel',
  slot: 'ContentTitle',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary
  })
});

export const ContentBody = superstyled({
  name: 'StandaloneReportPanel',
  slot: 'ContentBody',
  tag: Box,
  styles: ({ theme }) => ({
    flex: 1,
    overflow: 'auto',
    padding: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1.5)
    }
  })
});

export const DownloadButton = superstyled({
  name: 'StandaloneReportPanel',
  slot: 'DownloadButton',
  tag: Button,
  styles: ({ theme }) => ({
    alignSelf: 'center',
    padding: theme.spacing(1.5, 2)
  })
});

export const FooterSectionContent = superstyled({
  name: 'StandaloneReportPanel',
  slot: 'FooterContent',
  tag: Box,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(4),
    paddingLeft: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(0),
      marginTop: theme.spacing(2)
    }
  })
});
